module.exports = __webpack_public_path__ + "img/dashboard-img.06385e2c.png";